import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgBrowser = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.667 2.667H3.333C2.593 2.667 2 3.267 2 4v8c0 .733.593 1.333 1.333 1.333h9.334c.733 0 1.333-.6 1.333-1.333V4c0-.733-.593-1.333-1.333-1.333zm0 9.333H3.333V5.333h9.334V12z",
		fillRule: "nonzero"
	})
});
export default SvgBrowser;
